/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import test_xlarge from './images/test_xlarge.svg';
import clipboard_chat from './images/clipboard_chat.svg';
import doc_sign from './images/document_signature.svg';
import identification from './images/identification.svg';
import person from './images/person.svg';

export namespace CustomImage {
  export interface Props extends React.HTMLAttributes<HTMLImageElement> {
    imageName: string;
    size?: 'small' | 'xlarge';
  }
}

const styles = StyleSheet.create({
  xlarge: {
    width: 120,
    height: 120,
  },
  small: {
    width: 50,
    height: 50,
  },
});

const getImage = (imageName: string) => {
  switch (imageName) {
    case 'test_xlarge':
      return test_xlarge;
    case 'clipboard_chat':
      return clipboard_chat;
    case 'doc_sign':
      return doc_sign;
    case 'identification':
      return identification;
    case 'person':
      return person;
    default:
      return null;
  }
};

export const CustomImage: React.FC<CustomImage.Props> = ({ imageName, size = 'xlarge', ...htmlProps }) => {
  const image = getImage(imageName);
  return <img className={css(styles[size])} src={image} aria-hidden="true" {...htmlProps} alt={imageName} />;
};
